import React from 'react';
import { Container } from '../helper';
import DocumentCarousel from './document-carousel/DocumentCarousel';
import { useAdmin, useRoles } from '../api/user-api/UserAPI';
import { getAssociationDocuments } from './document-card/document-cards';

/**
 * The landing page a user will first arrive to when logging into DataLink.
 * Displays the potential association jobs to the user via card format
 * @constructor
 */
const LandingPage = function () {
  const isAdmin = useAdmin();
  const userRoles = useRoles();

  const associationDocuments = getAssociationDocuments(userRoles, isAdmin);

  return (
    <Container>
      <DocumentCarousel associationDocuments={associationDocuments} />
    </Container>
  );
};

export default LandingPage;
